"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebsocketProvider = void 0;
const react_1 = __importDefault(require("react"));
const web_socket_hook_1 = require("./web-socket-hook");
const web_socket_context_1 = require("./web-socket-context");
function WebsocketProvider({ wsUrl, destinations, children, debug = true, }) {
    const { context } = web_socket_hook_1.useWebsocket({
        wsUrl,
        destinations,
        debug,
    });
    return (react_1.default.createElement(web_socket_context_1.WebsocketContext.Provider, { value: context }, context.isWsActive && children));
}
exports.WebsocketProvider = WebsocketProvider;
//# sourceMappingURL=web-socket-provider.js.map